import { Injectable } from '@angular/core';
import { Inscription } from 'src/app/pages/virtual-class/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(private httpSv: HttpService, private uiSv: UiServices) {}

  async suspend(inscription) {
    try {
      const res = await this.httpSv.itemAction(
        {
          isSuspended: !inscription.isSuspended,
          inscriptionId: inscription.id,
        },
        'client/inscription',
        'suspended'
      );

      if (res.status) {
        this.uiSv.showToast('Actualizado exitosamente');
      }
    } catch (error) {}
  }

  async approveOrDecline(inscription: Inscription, isApprove) {
    if (inscription.status === 'Pending' || inscription.status === 'Pago') {
      await this.uiSv.showLoading();
      let route = '';
      let id = undefined;
      if (
        inscription?.paymentPending?.id &&
        !inscription?.paymentPending?.orderId
      ) {
        route = 'payment';
        id = inscription?.paymentPending?.id;
      } else {
        route = 'order';
        id =
          inscription?.paymentPending?.orderId ||
          inscription?.paymentAprobed.orderId;
      }

      const res = await this.httpSv.itemAction(
        {
          id,
        },
        `${route}/admin`,
        isApprove ? 'approve' : 'decline'
      );

      await this.uiSv.loading.dismiss();
      if (res.status) {
        await this.uiSv.presentAlert(
          'Se ha actualizado el estatus de la suscripción'
        );
      }
      return true;
    }
  }
}
